// services/everpro/everpro-callback.ts — kelola callback URL Everpro per-brand via S2 proxy
// Everpro kirim webhook (AWB + tracking) ke URL ini; backend S2 validasi header x-everpro-key.
import { everproFetch } from './everpro-auth';

export interface EverproCallbackUrls {
  awbCallbackUrl?: string;
  bulkOrderCallbackUrl?: string;
  lastMileCallbackUrl?: string;
  shipmentCallbackUrl?: string;
}

export async function getEverproCallbackUrl(brandId: string): Promise<EverproCallbackUrls | null> {
  if (!brandId) return null;
  try {
    const res = await everproFetch(brandId, '/callback/v1', { method: 'GET' });
    if (!res.ok) return null;
    const json = await res.json();
    const d = json?.data ?? {};
    return {
      awbCallbackUrl: d.awb_callback_url,
      bulkOrderCallbackUrl: d.bulk_order_callback_url,
      lastMileCallbackUrl: d.last_mile_callback_url,
      shipmentCallbackUrl: d.shipment_callback_url,
    };
  } catch {
    return null;
  }
}

export async function setEverproCallbackUrl(
  urls: Partial<EverproCallbackUrls>,
  brandId: string,
): Promise<void> {
  if (!brandId) throw new Error('Everpro: brandId wajib');

  const body: Record<string, string> = {};
  if (urls.awbCallbackUrl != null) body.awb_callback_url = urls.awbCallbackUrl;
  if (urls.bulkOrderCallbackUrl != null) body.bulk_order_callback_url = urls.bulkOrderCallbackUrl;
  if (urls.lastMileCallbackUrl != null) body.last_mile_callback_url = urls.lastMileCallbackUrl;
  if (urls.shipmentCallbackUrl != null) body.shipment_callback_url = urls.shipmentCallbackUrl;

  const res = await everproFetch(brandId, '/callback/v1', {
    method: 'PUT',
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    let message = '';
    try { message = JSON.parse(detail).message || ''; } catch { /* */ }
    throw new Error(message || `Everpro callback setup: ${res.status} ${res.statusText}`);
  }
}
